module.exports = "<div class=\"app-container\">  \n  <alg-sconto-header [reverse]=\"discountComplete\"></alg-sconto-header>  \n  <alg-sconto-hero [reverse]=\"discountComplete\"></alg-sconto-hero>\n  <alg-sconto-form [reverse]=\"discountComplete\"></alg-sconto-form>  \n  <alg-sconto-footer></alg-sconto-footer>  \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/alg-sconto/alg-sconto.component.html
// module id = ./src/app/pages/alg-sconto/alg-sconto.component.html
// module chunks = main